export const ResizeImageToSquare = (file: File, size = 200): Promise<File> =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext("2d");

      if (!ctx) {
        reject(new Error("Canvas not supported"));
        return;
      }

      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, size, size);

      const scale = Math.min(size / img.width, size / img.height);
      const newWidth = img.width * scale;
      const newHeight = img.height * scale;
      const dx = (size - newWidth) / 2;
      const dy = (size - newHeight) / 2;

      ctx.drawImage(img, dx, dy, newWidth, newHeight);

      canvas.toBlob(blob => {
        if (blob) {
          resolve(new File([blob], file.name, { type: file.type }));
        } else {
          reject(new Error("Failed to convert canvas to Blob"));
        }
      }, file.type);
    };

    img.onerror = () => reject(new Error("Failed to load image"));
  });
